<script setup lang="ts">
import { computed, ref } from 'vue';
import useNotice from '../hook/useNotice';
import type { PersonalCenterList } from './Public/type';
import BaseContent from './Public/BaseContent.vue';

const props = defineProps<{
  config: PersonalCenterList[0];
}>();

const configWithoutComp = computed(() => {
  const { comp, ...others } = props.config || {};
  return others;
});

const visible = ref(false);

const showDialog = () => {
  visible.value = true;
};

const { tableData, TypeEnums, handleRead } = useNotice();

const tableRowClassName = ({ row, rowIndex }: any) => {
  // if (row.isRead) {
  //   return 'success-row';
  // }
  return '';
};
</script>

<template>
  <div>
    <BaseContent :config="configWithoutComp" pure @click="showDialog" />
    <el-dialog v-model="visible" title="消息中心" width="800" append-to-body>
      <!-- 消息表格 -->
      <el-table
        :data="tableData"
        stripe
        style="width: 100%"
        class="is-header-split no-border-bottom"
        :border="false"
        :row-class-name="tableRowClassName"
        size="small"
      >
        <el-table-column prop="type" label="类型" width="74">
          <template #default="scope">
            <el-tag :type="TypeEnums[scope.row.type].type"> {{ TypeEnums[scope.row.type].title }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="消息标题" width="200" show-overflow-tooltip>
          <template #default="scope">
            <span>{{ scope.row.title }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="content" label="消息内容" show-overflow-tooltip />
        <el-table-column label="操作" width="80">
          <template #default="scope">
            <el-button type="primary" link @click="handleRead(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
@import '../styles/var.scss';

:deep(.#{$namespace}-table__inner-wrapper) {
  &::before {
    background-color: transparent;
  }
}

:deep(.#{$namespace}-table__row) {
  &.success-row td {
    background-color: #f0f9eb !important;
  }
}
</style>
